import React from 'react';
import { useTheme } from '../context/ThemeContext';
// import { ReactComponent as VlrIcon } from '../assets/png/vlr_token-icon-large.svg';
import VlrIcon from '../assets/png/vlr-token-icon.png';
import { ReactComponent as CloseButtonDark } from '../assets/svg/modal_close_btn-dark.svg';
import { ReactComponent as CloseButtonLight } from '../assets/svg/modal_close_btn-light.svg';
import modalTextureDark from '../assets/png/modal_texture-dark.png';
import modalTextureLight from '../assets/png/modal_texture-light.png';

interface ClaimConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const ClaimConfirmationModal: React.FC<ClaimConfirmationModalProps> = ({ isOpen, onClose }) => {
  const { theme } = useTheme();

  if (!isOpen) return null;

  const handleBackdropClick = (e: React.MouseEvent<HTMLDivElement>): void => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const handleStake = (): void => {
    // TODO: Implement stake functionality
    console.log('Stake VLR clicked');
    onClose();
  };

  const handleShareOnX = (): void => {
    // Open Twitter/X with pre-filled tweet
    const tweetText =
      "I've claimed my $VLR rewards on Velora, check your eligibility here: https://distribution.velora.xyz/";
    const tweetUrl = `https://twitter.com/intent/tweet?text=${encodeURIComponent(tweetText)}`;
    window.open(tweetUrl, '_blank');
  };

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-85 flex items-end md:items-center justify-center z-[9999]"
      onClick={handleBackdropClick}
    >
      {/* Gradient border wrapper */}
      <div className="relative w-full md:w-[400px] h-auto bg-gradient-to-b from-white/20 via-white/10 to-white/5 dark:from-white/10 dark:via-white/5 dark:to-transparent rounded-t-[16px] md:rounded-[16px] p-[1px] max-w-full md:max-w-none">
        <div
          className="relative w-full h-full bg-contrast-8 dark:bg-contrast-2 rounded-t-[15px] md:rounded-[15px] overflow-hidden"
          style={{
            backgroundImage:
              theme === 'dark' ? `url(${modalTextureDark})` : `url(${modalTextureLight})`,
            backgroundSize: theme === 'dark' ? '100% auto' : 'auto 120px',
            backgroundPosition: 'right -10px bottom -10px',
            backgroundRepeat: 'no-repeat',
          }}
        >
          {/* Content Wrapper */}
          <div className="p-6 h-full flex flex-col relative z-10">
            {/* Close Button */}
            <div className="flex justify-end mb-2">
              <button
                onClick={onClose}
                className="w-[40px] h-[40px] flex items-center justify-center"
              >
                {theme === 'dark' ? (
                  <CloseButtonDark className="w-[40px] h-[40px]" />
                ) : (
                  <CloseButtonLight className="w-[40px] h-[40px]" />
                )}
              </button>
            </div>

            {/* Content */}
            <div className="flex flex-col items-center gap-5 flex-1">
              {/* Success Icon */}
              <div className="w-16 h-16 bg-primary-papaya rounded-full flex items-center justify-center">
                <img src={VlrIcon} alt="VLR Token" className="w-16 h-16" />
              </div>

              {/* Title */}
              <h3 className="text-contrast-3 dark:text-white text-[16px] md:text-[18px] font-medium font-geist text-center">
                You've claimed your tokens!
              </h3>

              {/* Description */}
              <div className="text-contrast-5 dark:text-contrast-6 text-[14px] font-geist text-center leading-[22px]">
                <p className="mb-4">
                  You can now stake $VLR to start earning monthly yield and get back up to 95% of
                  your gas fees.
                </p>
                <p>
                  Visit our{' '}
                  <button
                    onClick={() => window.open('https://help.velora.xyz/en/', '_blank')}
                    className="underline hover:text-primary-azul transition-colors cursor-pointer"
                  >
                    Help Center
                  </button>{' '}
                  to learn more about the VLR staking system
                </p>
              </div>

              {/* Spacer to push buttons down */}
              <div className="flex-1"></div>

              {/* Action Buttons */}
              <div className="flex flex-col gap-4 w-full">
                <button
                  onClick={handleStake}
                  className="w-full h-12 bg-primary-azul hover:bg-opacity-90 text-white font-medium font-inter text-[14px] rounded-[8px] transition-all shadow-[0_2px_12px_0_rgba(123,138,255,0.10),0_0_14px_0_rgba(118,133,255,0.50)_inset,0_0_16px_0_rgba(90,63,229,0.15)] flex items-center justify-center"
                >
                  Stake $VLR
                </button>

                <button
                  onClick={handleShareOnX}
                  className="w-full h-12 bg-contrast-8 dark:bg-contrast-3 hover:bg-contrast-7 dark:hover:bg-contrast-1 text-contrast-3 dark:text-contrast-7 font-medium font-inter text-[14px] rounded-[8px] transition-all flex items-center justify-center"
                >
                  Share the news on X.com
                </button>
              </div>

              {/* Pagination Indicator */}
              <div className="flex items-center justify-center gap-1 mt-5">
                <div className="w-2 h-2 bg-contrast-5 dark:bg-contrast-4 rounded-full"></div>
                <div className="w-2 h-2 bg-primary-papaya rounded-full"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ClaimConfirmationModal;
